import { render, staticRenderFns } from "./DetailsSideBar.vue?vue&type=template&id=fd3eac4e&scoped=true"
import script from "./DetailsSideBar.vue?vue&type=script&lang=js"
export * from "./DetailsSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3eac4e",
  null
  
)

export default component.exports